import CollapsedListOptionsModel from '@/Models/collapsedListOptionsModel';
import RequestSummaryDto from '@/Types/requestSummaryDto';
class RequestSummaryModel {
  isRequestLastAccessed: boolean;
  requestId: string;
  referenceNumber: string;
  requestTypeDescription: string;
  requestStatusForDisplay: string;
  requestPriorityForDisplay: string;
  requestDateTime: string;
  agencyName: string;
  investigatorDisplayName: string;
  requiredByDate: string;
  hasResponse: boolean;
  responseTimestamp: string;
  sentToRecipientList: string[];
  collapsedListOptions: CollapsedListOptionsModel;
  assignedPersonaName: string;
  assignedGroupName: string;
  discussionMessagesCount: number;
  caseNameClaim?: { key: string; value: string };
  rmsIdClaim?: { key: string; value: string };

  constructor(serverModel: RequestSummaryDto, previousRequestId: string) {
    this.isRequestLastAccessed = serverModel.requestId === previousRequestId;
    this.requestId = serverModel.requestId;
    this.referenceNumber = serverModel.referenceNumber;
    this.requestTypeDescription = serverModel.requestTypeDescription;
    this.requestStatusForDisplay = serverModel.requestStatusForDisplay;
    this.requestPriorityForDisplay = serverModel.requestPriorityForDisplay;
    this.requestDateTime = serverModel.requestDateTime;
    this.agencyName = serverModel.agencyName;
    this.investigatorDisplayName = serverModel.investigatorDisplayName;
    this.requiredByDate = serverModel.requiredByDate;
    this.hasResponse = serverModel.hasResponse;
    this.responseTimestamp = serverModel.responseTimestamp;
    this.sentToRecipientList = serverModel.sentToRecipientList;
    this.collapsedListOptions = new CollapsedListOptionsModel(this.sentToRecipientList);
    this.assignedPersonaName = serverModel.assignedPersonaName;
    this.assignedGroupName = serverModel.assignedGroupName;
    this.discussionMessagesCount = serverModel.discussionMessagesCount;
    this.caseNameClaim = serverModel.claims?.find(x => x.key === 'CaseName');
    this.rmsIdClaim = serverModel.claims?.find(x => x.key === 'RMSID');
  }
}

export default RequestSummaryModel;
